// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Box,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Checkbox,
//   Paper,
//   CircularProgress,
//   Alert,
//   Collapse,
//   IconButton,
//   TablePagination,
//   InputAdornment,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import FilterListIcon from '@mui/icons-material/FilterList';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import SearchIcon from '@mui/icons-material/Search';
// import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import Autocomplete from "@mui/material/Autocomplete";
// import { getSecureDevId } from "../../../utils/storageHelpers";

// // --- Types and Interfaces ---
// interface DocumentData {
//   docMid: number;
//   fileNo: string;
//   fileDef: string;
//   synopsis: string;
//   fDate: string;
//   complt: string | null;
//   fileType: string | null;
//   fileType_Name: string;
//   divisionid: number;
//   department_Name: string;
//   fileTypId: number;
// }

// interface AutoCompleteOption {
//   label: string;
//   value: number | string;
// }

// interface Department {
//   id: number;
//   nodeID: number;
//   name: string;
//   titleID: number;
// }

// interface TableRowData {
//   id: number;
//   fileNo: string;
//   docMid: number;
//   fileDef: string;
//   isSelected: boolean;
// }

// // Validation schema
// const validationSchema = Yup.object({
//   docID: Yup.number()
//     .min(0, "Document Type is required")
//     .required("Document Type is required"),
// });

// const UpdatePDF: React.FC = () => {
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   // --- Secure ID ---
//   const devId = getSecureDevId();
//   const devIdNum = devId !== -1 ? devId : -1;
//   const isDevIdPresent = devIdNum !== -1;

//   // --- State Variables ---
//   const [tableData, setTableData] = useState<TableRowData[]>([]);
//   const [filteredData, setFilteredData] = useState<TableRowData[]>([]);
//   const [isLoadingDocs, setIsLoadingDocs] = useState<boolean>(false);
//   const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
//   const [isLoadingDocTypes, setIsLoadingDocTypes] = useState<boolean>(false);

//   // --- Pagination State ---
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // --- Search State ---
//   const [searchQuery, setSearchQuery] = useState("");

//   // --- Filter States ---
//   const [filtersExpanded, setFiltersExpanded] = useState(true);
  
//   // Options for dropdowns
//   const [docTypeOptions, setDocTypeOptions] = useState<AutoCompleteOption[]>([]);
//   const [synopsisOptions, setSynopsisOptions] = useState<AutoCompleteOption[]>([]);
//   const [departmentOptions, setDepartmentOptions] = useState<AutoCompleteOption[]>([]);
//   const [fileNoOptions, setFileNoOptions] = useState<AutoCompleteOption[]>([]);

//   // Selected filter values
//   const [selectedDocType, setSelectedDocType] = useState<AutoCompleteOption | null>(null);
//   const [selectedSynopsis, setSelectedSynopsis] = useState<AutoCompleteOption | null>(null);
//   const [selectedDepartment, setSelectedDepartment] = useState<AutoCompleteOption | null>(null);
//   const [selectedFileNo, setSelectedFileNo] = useState<AutoCompleteOption | null>(null);

//   // Loading states
//   const [loadingDepartments, setLoadingDepartments] = useState(false);

//   // Refs
//   const initialSetupDone = useRef(false);
//   const initialDataFetched = useRef(false);

//   // --- Formik ---
//   const formik = useFormik({
//     initialValues: {
//       docID: -1,
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       setIsSubmitting(true);

//       const selectedFiles = tableData.filter((row) => row.isSelected);

//       if (selectedFiles.length === 0) {
//         toast.warn("No file selected");
//         setIsSubmitting(false);
//         return;
//       }

//       // सिर्फ rename ही होगा अब
//       const payload = {
//         udatePdfFiles: selectedFiles.map((row) => ({
//           docID: row.docMid,
//           doc_Name: row.fileDef,
//         })),
//       };
      
//       try {
//         const response = await axios.post(
//           HOST_URL.HOST_URL2 + `DocMangr/UpdatePdfFileName`,
//           payload
//         );
//         if (response.data.isSuccess) {
//           toast.success(response.data.mesg);
//           setTableData((prev) =>
//             prev.map((row) => ({ ...row, isSelected: false }))
//           );
//           fetchDocuments();
//         } else {
//           toast.error(response.data.mesg);
//         }
//       } catch (error) {
//         console.error("Error submitting update:", error);
//         toast.error("Update Failed");
//       } finally {
//         setIsSubmitting(false);
//       }
//     },
//   });

//   // --- Filter Change Handlers ---
//   const handleDocTypeChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     setSelectedDocType(newValue);
//     formik.setFieldValue("docID", newValue ? Number(newValue.value) : -1);
//   };

//   const handleSynopsisChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     setSelectedSynopsis(newValue);
//   };

//   const handleDepartmentChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     if (!isDevIdPresent) {
//       setSelectedDepartment(newValue);
//     }
//   };

//   const handleFileNoChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
//     setSelectedFileNo(newValue);
//   };

//   const toggleFilters = () => {
//     setFiltersExpanded(!filtersExpanded);
//   };

//   const handleResetFilters = () => {
//     setSelectedDocType(null);
//     setSelectedSynopsis(null);
//     setSelectedFileNo(null);
//     setSearchQuery("");
    
//     if (!isDevIdPresent) {
//       setSelectedDepartment(null);
//     }
    
//     formik.setFieldValue("docID", -1);
//   };

//   // --- Search Handler ---
//   const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchQuery(event.target.value);
//     setPage(0); // Reset to first page on search
//   };

//   // --- API Functions ---
//   const fetchDocTypes = useCallback(async () => {
//     setIsLoadingDocTypes(true);
//     const collectData = { docID: -1, parentDocId: -1, userId: "" };

//     try {
//       const response = await axios.post<{ data: any[] }>(
//         HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
//         collectData
//       );

//       const docTypes = response.data.data || [];
//       const options = docTypes.map((item: any) => ({
//         label: item["doc_Name"],
//         value: item["docID"]
//       }));

//       setDocTypeOptions(options);
//     } catch (error) {
//       console.error("Error fetching doc types:", error);
//       toast.error("Failed to fetch document types.");
//     } finally {
//       setIsLoadingDocTypes(false);
//     }
//   }, []);

//   const fetchDepartments = useCallback(async () => {
//     setLoadingDepartments(true);
//     const collectData = { id: isDevIdPresent ? devIdNum : -1, nodeID: -1, titleID: -1 };

//     try {
//       const response = await axios.post<{ data: Department[] }>(
//         HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
//         collectData
//       );

//       const departments = response.data.data || [];
//       const options = departments.map((dept: Department) => ({
//         label: dept.name,
//         value: dept.id
//       }));

//       setDepartmentOptions(options);

//       if (isDevIdPresent) {
//         const foundDept = options.find(dept => dept.value === devIdNum);
//         if (foundDept) {
//           setSelectedDepartment(foundDept);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching departments:", error);
//       toast.error("Failed to fetch departments.");
//     } finally {
//       setLoadingDepartments(false);
//     }
//   }, [isDevIdPresent, devIdNum]);

//   const fetchDocuments = useCallback(async () => {
//     setIsLoadingDocs(true);

//     const collectData = {
//       docMid: -1,
//       fileTypId: selectedDocType ? Number(selectedDocType.value) : -1,
//       divisionid: isDevIdPresent
//         ? devIdNum
//         : selectedDepartment
//           ? Number(selectedDepartment.value)
//           : -1,
//       subDeptID: -1,
//       subsubjId: -1,
//       user_Id: -1,
//       fileNo: selectedFileNo ? String(selectedFileNo.value) : "",
//       synopsis: selectedSynopsis ? String(selectedSynopsis.value) : "",
//       complt: "",
//     };

//     try {
//       const response = await axios.post<{ data: DocumentData[] }>(
//         HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//         collectData
//       );

//       const documents = response.data.data || [];

//       // Generate filter options from documents
//       generateAutoCompleteOptions(documents);

//       // Format data for table
//       const formattedData: TableRowData[] = documents.map(
//         (item: DocumentData, index: number) => ({
//           id: item["docMid"] || index,
//           fileNo: item["fileNo"],
//           docMid: item["docMid"],
//           fileDef: item["fileDef"],
//           isSelected: false,
//         })
//       );
      
//       setTableData(formattedData);
//       setFilteredData(formattedData); // Initialize filtered data
//       setPage(0); // Reset to first page
//     } catch (error) {
//       console.error("Error fetching documents:", error);
//       toast.error("Failed to fetch documents.");
//       setTableData([]);
//       setFilteredData([]);
//     } finally {
//       setIsLoadingDocs(false);
//     }
//   }, [
//     selectedDocType,
//     selectedSynopsis,
//     selectedDepartment,
//     selectedFileNo,
//     isDevIdPresent,
//     devIdNum,
//   ]);

//   const generateAutoCompleteOptions = useCallback((documents: DocumentData[]) => {
//     // Synopsis Options
//     const synopses = Array.from(new Set(documents
//       .map(doc => doc.synopsis)
//       .filter(Boolean)))
//       .map(synopsis => ({
//         label: synopsis as string,
//         value: synopsis as string
//       }));
//     setSynopsisOptions(synopses);

//     // File No Options
//     const fileNos = Array.from(new Set(documents
//       .map(doc => doc.fileNo)
//       .filter(Boolean)))
//       .map(fileNo => ({
//         label: fileNo as string,
//         value: fileNo as string
//       }));
//     setFileNoOptions(fileNos);
//   }, []);

//   // --- Filter by Synopsis (Filename) and Search ---
//   useEffect(() => {
//     if (tableData.length > 0) {
//       let filtered = [...tableData];
      
//       // Apply synopsis/filename filter (dropdown selection)
//       if (selectedSynopsis && selectedSynopsis.value) {
//         filtered = filtered.filter(item => 
//           item.fileDef && item.fileDef.toLowerCase().includes(String(selectedSynopsis.value).toLowerCase())
//         );
//       }
      
//       // Apply global search query (free text)
//       if (searchQuery) {
//         filtered = filtered.filter(item => 
//           (item.fileNo && item.fileNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
//           (item.fileDef && item.fileDef.toLowerCase().includes(searchQuery.toLowerCase()))
//         );
//       }
      
//       setFilteredData(filtered);
//       setPage(0); // Reset to first page when filters change
//     } else {
//       setFilteredData([]);
//     }
//   }, [selectedSynopsis, searchQuery, tableData]);

//   // --- Pagination Handlers ---
//   const handleChangePage = (event: unknown, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // --- Get current page data ---
//   const paginatedData = useMemo(() => {
//     const start = page * rowsPerPage;
//     const end = start + rowsPerPage;
//     return filteredData.slice(start, end);
//   }, [filteredData, page, rowsPerPage]);

//   // --- useEffect Hooks ---
//   useEffect(() => {
//     const initData = async () => {
//       if (initialSetupDone.current) return;
      
//       try {
//         await fetchDepartments();
//         await fetchDocTypes();
//         initialSetupDone.current = true;
//       } catch (error) {
//         console.error("Error fetching initial data:", error);
//       }
//     };

//     initData();
//   }, [fetchDepartments, fetchDocTypes]);

//   useEffect(() => {
//     if (!initialSetupDone.current || initialDataFetched.current) return;

//     const timer = setTimeout(() => {
//       fetchDocuments();
//       initialDataFetched.current = true;
//     }, 300);

//     return () => clearTimeout(timer);
//   }, [initialSetupDone.current, fetchDocuments]);

//   useEffect(() => {
//     if (!initialDataFetched.current) return;

//     const timer = setTimeout(() => {
//       fetchDocuments();
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [
//     selectedDocType?.value,
//     selectedDepartment?.value,
//     selectedFileNo?.value,
//     fetchDocuments,
//   ]);

//   // --- Event Handlers for Table ---
//   const handleInputChange = (id: number, field: keyof TableRowData, value: any) => {
//     setTableData((prev) => {
//       const updated = prev.map((row) => (row.id === id ? { ...row, [field]: value } : row));
      
//       // Also update filtered data to reflect changes
//       setFilteredData((prevFiltered) => 
//         prevFiltered.map((row) => (row.id === id ? { ...row, [field]: value } : row))
//       );
      
//       return updated;
//     });
//   };

//   const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const isChecked = event.target.checked;
    
//     // Update all rows in filtered data
//     setFilteredData((prev) => prev.map((row) => ({ ...row, isSelected: isChecked })));
    
//     // Also update main table data
//     setTableData((prev) => 
//       prev.map((row) => {
//         const isInFiltered = filteredData.some(f => f.id === row.id);
//         return isInFiltered ? { ...row, isSelected: isChecked } : row;
//       })
//     );
//   };

//   // Check if a row is selected (for header checkbox)
//   const numSelected = filteredData.filter((row) => row.isSelected).length;
//   const rowCount = filteredData.length;
//   const isAllSelected = rowCount > 0 && numSelected === rowCount;

//   return (
//     <Box sx={{ p: 3, backgroundColor: 'background.default', minHeight: 'calc(100vh - 64px)' }}>
//       <ToastApp />
//       <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//         {/* Header */}
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
//           <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
//             {t("text.UpdatePdf")}
//           </Typography>
//           <Button variant="outlined" size="small" onClick={() => navigate(-1)} startIcon={<ArrowBackSharpIcon />} sx={{ borderColor: 'primary.contrastText', color: 'primary.contrastText', '&:hover': { bgcolor: 'primary.dark' } }}>
//             {t("text.Back")}
//           </Button>
//         </Box>

//         <CardContent sx={{ p: 3 }}>
//           <form onSubmit={formik.handleSubmit}>
//             <Grid container spacing={3}>
//               {/* Filters Section */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ mb: 2 }}>
//                   <CardContent sx={{ p: 2 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={toggleFilters}>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <FilterListIcon sx={{ mr: 1, fontSize: 20 }} />
//                         <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 500 }}>Filters</Typography>
//                       </Box>
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Button variant="outlined" size="small" onClick={(e) => { e.stopPropagation(); handleResetFilters(); }} sx={{ mr: 1, minWidth: 'auto', px: 1.5 }}>Reset</Button>
//                         <IconButton size="small">{filtersExpanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
//                       </Box>
//                     </Box>

//                     <Collapse in={filtersExpanded}>
//                       <Grid container spacing={2} sx={{ mt: 1 }}>
//                         {/* 1. Department Filter */}
//                         <Grid item xs={12} sm={6} md={3}>
//                           <Autocomplete
//                             options={departmentOptions}
//                             value={selectedDepartment}
//                             onChange={handleDepartmentChange}
//                             getOptionLabel={(option) => option.label}
//                             loading={loadingDepartments}
//                             disabled={isDevIdPresent}
//                             size="small"
//                             renderInput={(params) => (
//                               <TextField 
//                                 {...params} 
//                                 label="Department" 
//                                 placeholder={isDevIdPresent ? "Pre-selected from secure ID" : "Select department"} 
//                                 InputProps={{ 
//                                   ...params.InputProps, 
//                                   endAdornment: ( 
//                                     <> 
//                                       {loadingDepartments ? <CircularProgress size={18} /> : null} 
//                                       {params.InputProps.endAdornment} 
//                                     </> 
//                                   ) 
//                                 }} 
//                               />
//                             )}
//                           />
//                         </Grid>

//                         {/* 2. Document Type Filter */}
//                         <Grid item xs={12} sm={6} md={3}>
//                           <Autocomplete
//                             options={docTypeOptions}
//                             value={selectedDocType}
//                             onChange={handleDocTypeChange}
//                             getOptionLabel={(option) => option.label}
//                             loading={isLoadingDocTypes}
//                             size="small"
//                             renderInput={(params) => (
//                               <TextField 
//                                 {...params} 
//                                 label="Document Type" 
//                                 placeholder="Select document type"
//                                 error={formik.touched.docID && Boolean(formik.errors.docID)}
//                                 helperText={formik.touched.docID && formik.errors.docID}
//                                 InputProps={{ 
//                                   ...params.InputProps, 
//                                   endAdornment: ( 
//                                     <> 
//                                       {isLoadingDocTypes ? <CircularProgress size={18} /> : null} 
//                                       {params.InputProps.endAdornment} 
//                                     </> 
//                                   ) 
//                                 }} 
//                               />
//                             )}
//                           />
//                         </Grid>

//                         {/* 3. File Name (Synopsis) Filter */}
//                         <Grid item xs={12} sm={6} md={3}>
//                           <Autocomplete
//                             options={synopsisOptions}
//                             value={selectedSynopsis}
//                             onChange={handleSynopsisChange}
//                             getOptionLabel={(option) => option.label}
//                             size="small"
//                             renderInput={(params) => (
//                               <TextField {...params} label="File Name" placeholder="Select file name" />
//                             )}
//                           />
//                         </Grid>

//                         {/* 4. File No Filter */}
//                         <Grid item xs={12} sm={6} md={3}>
//                           <Autocomplete
//                             options={fileNoOptions}
//                             value={selectedFileNo}
//                             onChange={handleFileNoChange}
//                             getOptionLabel={(option) => option.label}
//                             size="small"
//                             renderInput={(params) => (
//                               <TextField {...params} label="File No" placeholder="Select file number" />
//                             )}
//                           />
//                         </Grid>
//                       </Grid>
//                     </Collapse>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Global Search Bar - Above Table */}
//               <Grid item xs={12} sx={{ mt: -1 }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
//                   <TextField
//                     variant="outlined"
//                     size="small"
//                     placeholder="Global Search by File No or File Name..."
//                     value={searchQuery}
//                     onChange={handleSearchChange}
//                     sx={{ width: '350px' }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <SearchIcon />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               {/* Table Section */}
//               <Grid item xs={12} sx={{ mt: -2 }}>
                
//                 {isLoadingDocs ? (
//                   <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}><CircularProgress /></Box>
//                 ) : filteredData.length === 0 ? (
//                   <Alert severity="info" sx={{ mt: 2 }}>No documents found for the selected filters.</Alert>
//                 ) : (
//                   <>
//                     <TableContainer component={Paper} elevation={1} sx={{ maxHeight: '50vh' }}>
//                       <Table stickyHeader>
//                         <TableHead>
//                           {/* Table Headers */}
//                           <TableRow sx={{ '& th': { backgroundColor: 'lightblue', fontWeight: 'bold' } }}>
//                             <TableCell padding="checkbox">
//                               <Checkbox 
//                                 color="primary" 
//                                 indeterminate={numSelected > 0 && numSelected < rowCount} 
//                                 checked={isAllSelected} 
//                                 onChange={handleSelectAll} 
//                                 disabled={isSubmitting} 
//                               />
//                             </TableCell>
//                             <TableCell>File No</TableCell>
//                             <TableCell>PDF File Name</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {paginatedData.map((row, index) => (
//                             <TableRow 
//                               hover 
//                               key={row.id} 
//                               selected={row.isSelected}
//                               sx={{ 
//                                 backgroundColor: index % 2 === 0 ? '#fafafa' : '#ffffff',
//                                 '&:hover': {
//                                   backgroundColor: '#f5f5f5 !important',
//                                 }
//                               }}
//                             >
//                               <TableCell padding="checkbox">
//                                 <Checkbox 
//                                   color="primary" 
//                                   checked={row.isSelected} 
//                                   onChange={(e) => handleInputChange(row.id, "isSelected", e.target.checked)} 
//                                   disabled={isSubmitting} 
//                                 />
//                               </TableCell>
//                               <TableCell>{row.fileNo}</TableCell>
//                               <TableCell>
//                                 <TextField 
//                                   variant="outlined" 
//                                   size="small" 
//                                   fullWidth 
//                                   value={row.fileDef} 
//                                   onChange={(e) => handleInputChange(row.id, "fileDef", e.target.value)} 
//                                   disabled={!row.isSelected || isSubmitting} 
//                                   sx={{ 
//                                     backgroundColor: row.isSelected ? 'white' : 'transparent', 
//                                     minWidth: '250px' 
//                                   }} 
//                                 />
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>

//                     {/* Pagination */}
//                     <TablePagination
//                       rowsPerPageOptions={[5, 10, 25, 50, 100]}
//                       component="div"
//                       count={filteredData.length}
//                       rowsPerPage={rowsPerPage}
//                       page={page}
//                       onPageChange={handleChangePage}
//                       onRowsPerPageChange={handleChangeRowsPerPage}
//                       labelRowsPerPage="Rows per page:"
//                     />
//                   </>
//                 )}
//               </Grid>

//               {/* Action Buttons */}
//               {filteredData.length > 0 && (
//                 <Grid item xs={12} container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
//                   <Grid item xs={12} sm={4} md={3}>
//                     <Button type="submit" variant="contained" color="primary" fullWidth disabled={isSubmitting || numSelected === 0} startIcon={isSubmitting ? <CircularProgress size={20} /> : null}>
//                       {isSubmitting ? "Saving..." : "Save"}
//                     </Button>
//                   </Grid>
//                   <Grid item xs={12} sm={4} md={3}>
//                     <Button type="reset" variant="outlined" color="secondary" fullWidth disabled={isSubmitting} onClick={() => { formik.resetForm(); handleResetFilters(); }}>
//                       {t("text.reset")}
//                     </Button>
//                   </Grid>
//                 </Grid>
//               )}
//             </Grid>
//           </form>
//         </CardContent>
//       </Paper>
//     </Box>
//   );
// };

// export default UpdatePDF;








import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Paper,
  CircularProgress,
  Alert,
  Collapse,
  IconButton,
  TablePagination,
  InputAdornment,
  AlertTitle,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { getSecureDevId } from "../../../utils/storageHelpers";
import { secureGetItem } from "../../../utils/encryption";

// --- Types and Interfaces ---
interface DocumentData {
  docMid: number;
  fileNo: string;
  fileDef: string;
  synopsis: string;
  fDate: string;
  complt: string | null;
  fileType: string | null;
  fileType_Name: string;
  divisionid: number;
  department_Name: string;
  fileTypId: number;
}

interface AutoCompleteOption {
  label: string;
  value: number | string;
}

interface Department {
  id: number;
  nodeID: number;
  name: string;
  titleID: number;
}

interface TableRowData {
  id: number;
  fileNo: string;
  docMid: number;
  fileDef: string;
  isSelected: boolean;
}

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
  isView: boolean;
}

// Validation schema
const validationSchema = Yup.object({
  docID: Yup.number()
    .min(0, "Document Type is required")
    .required("Document Type is required"),
});

const UpdatePDF: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // --- Secure ID ---
  const devId = getSecureDevId();
  const devIdNum = devId !== -1 ? devId : -1;
  const isDevIdPresent = devIdNum !== -1;

  // --- State Variables ---
  const [tableData, setTableData] = useState<TableRowData[]>([]);
  const [filteredData, setFilteredData] = useState<TableRowData[]>([]);
  const [isLoadingDocs, setIsLoadingDocs] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isLoadingDocTypes, setIsLoadingDocTypes] = useState<boolean>(false);
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
    isView: false,
  });

  // --- Pagination State ---
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // --- Search State ---
  const [searchQuery, setSearchQuery] = useState("");

  // --- Filter States ---
  const [filtersExpanded, setFiltersExpanded] = useState(true);
  
  // Options for dropdowns
  const [docTypeOptions, setDocTypeOptions] = useState<AutoCompleteOption[]>([]);
  const [synopsisOptions, setSynopsisOptions] = useState<AutoCompleteOption[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<AutoCompleteOption[]>([]);
  const [fileNoOptions, setFileNoOptions] = useState<AutoCompleteOption[]>([]);

  // Selected filter values
  const [selectedDocType, setSelectedDocType] = useState<AutoCompleteOption | null>(null);
  const [selectedSynopsis, setSelectedSynopsis] = useState<AutoCompleteOption | null>(null);
  const [selectedDepartment, setSelectedDepartment] = useState<AutoCompleteOption | null>(null);
  const [selectedFileNo, setSelectedFileNo] = useState<AutoCompleteOption | null>(null);

  // Loading states
  const [loadingDepartments, setLoadingDepartments] = useState(false);

  // Refs
  const initialSetupDone = useRef(false);
  const initialDataFetched = useRef(false);

  useEffect(() => {
    const data = secureGetItem("userdata");

    if (data && data.length > 0) {
      const userPermissionData = data[0]?.userPermission;
      const menudata = userPermissionData?.[0]?.parentMenu || [];

      for (let i = 0; i < menudata.length; i++) {
        const childMenudata = menudata[i]?.childMenu || [];
        const pathrow = childMenudata.find(
          (x: any) => x.path === location.pathname
        );

        if (pathrow) {
          setPermissionData({
            isAdd: pathrow.isAdd,
            isEdit: pathrow.isEdit,
            isPrint: pathrow.isPrint,
            isDel: pathrow.isDel,
            isView: pathrow.isView || false,
          });
          break;
        }
      }
    }
    setPermissionLoaded(true);
  }, [location.pathname]);

  // --- Formik ---
  const formik = useFormik({
    initialValues: {
      docID: -1,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!permissionData?.isAdd) {
        toast.error("You don't have permission to update PDFs");
        return;
      }
      setIsSubmitting(true);

      const selectedFiles = tableData.filter((row) => row.isSelected);

      if (selectedFiles.length === 0) {
        toast.warn("No file selected");
        setIsSubmitting(false);
        return;
      }

      // सिर्फ rename ही होगा अब
      const payload = {
        udatePdfFiles: selectedFiles.map((row) => ({
          docID: row.docMid,
          doc_Name: row.fileDef,
        })),
      };
      
      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `DocMangr/UpdatePdfFileName`,
          payload
        );
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          setTableData((prev) =>
            prev.map((row) => ({ ...row, isSelected: false }))
          );
          fetchDocuments();
        } else {
          toast.error(response.data.mesg);
        }
      } catch (error) {
        console.error("Error submitting update:", error);
        toast.error("Update Failed");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  // --- Filter Change Handlers ---
  const handleDocTypeChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedDocType(newValue);
    formik.setFieldValue("docID", newValue ? Number(newValue.value) : -1);
  };

  const handleSynopsisChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedSynopsis(newValue);
  };

  const handleDepartmentChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    if (!isDevIdPresent) {
      setSelectedDepartment(newValue);
    }
  };

  const handleFileNoChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedFileNo(newValue);
  };

  const toggleFilters = () => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setFiltersExpanded(!filtersExpanded);
  };

  const handleResetFilters = () => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedDocType(null);
    setSelectedSynopsis(null);
    setSelectedFileNo(null);
    setSearchQuery("");
    
    if (!isDevIdPresent) {
      setSelectedDepartment(null);
    }
    
    formik.setFieldValue("docID", -1);
  };

  // --- Search Handler ---
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSearchQuery(event.target.value);
    setPage(0); // Reset to first page on search
  };

  // --- API Functions ---
  const fetchDocTypes = useCallback(async () => {
    if (!permissionData?.isView) return;
    setIsLoadingDocTypes(true);
    const collectData = { docID: -1, parentDocId: -1, userId: "" };

    try {
      const response = await axios.post<{ data: any[] }>(
        HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
        collectData
      );

      const docTypes = response.data.data || [];
      const options = docTypes.map((item: any) => ({
        label: item["doc_Name"],
        value: item["docID"]
      }));

      setDocTypeOptions(options);
    } catch (error) {
      console.error("Error fetching doc types:", error);
      toast.error("Failed to fetch document types.");
    } finally {
      setIsLoadingDocTypes(false);
    }
  }, [permissionData?.isView]);

  const fetchDepartments = useCallback(async () => {
    if (!permissionData?.isView) return;
    setLoadingDepartments(true);
    const collectData = { id: isDevIdPresent ? devIdNum : -1, nodeID: -1, titleID: -1 };

    try {
      const response = await axios.post<{ data: Department[] }>(
        HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
        collectData
      );

      const departments = response.data.data || [];
      const options = departments.map((dept: Department) => ({
        label: dept.name,
        value: dept.id
      }));

      setDepartmentOptions(options);

      if (isDevIdPresent) {
        const foundDept = options.find(dept => dept.value === devIdNum);
        if (foundDept) {
          setSelectedDepartment(foundDept);
        }
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      toast.error("Failed to fetch departments.");
    } finally {
      setLoadingDepartments(false);
    }
  }, [isDevIdPresent, devIdNum, permissionData?.isView]);

  const fetchDocuments = useCallback(async () => {
    if (!permissionData?.isView) return;
    setIsLoadingDocs(true);

    const collectData = {
      docMid: -1,
      fileTypId: selectedDocType ? Number(selectedDocType.value) : -1,
      divisionid: isDevIdPresent
        ? devIdNum
        : selectedDepartment
          ? Number(selectedDepartment.value)
          : -1,
      subDeptID: -1,
      subsubjId: -1,
      user_Id: -1,
      fileNo: selectedFileNo ? String(selectedFileNo.value) : "",
      synopsis: selectedSynopsis ? String(selectedSynopsis.value) : "",
      complt: "",
    };

    try {
      const response = await axios.post<{ data: DocumentData[] }>(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        collectData
      );

      const documents = response.data.data || [];

      // Generate filter options from documents
      generateAutoCompleteOptions(documents);

      // Format data for table
      const formattedData: TableRowData[] = documents.map(
        (item: DocumentData, index: number) => ({
          id: item["docMid"] || index,
          fileNo: item["fileNo"],
          docMid: item["docMid"],
          fileDef: item["fileDef"],
          isSelected: false,
        })
      );
      
      setTableData(formattedData);
      setFilteredData(formattedData); // Initialize filtered data
      setPage(0); // Reset to first page
    } catch (error) {
      console.error("Error fetching documents:", error);
      toast.error("Failed to fetch documents.");
      setTableData([]);
      setFilteredData([]);
    } finally {
      setIsLoadingDocs(false);
    }
  }, [
    selectedDocType,
    selectedSynopsis,
    selectedDepartment,
    selectedFileNo,
    isDevIdPresent,
    devIdNum,
    permissionData?.isView,
  ]);

  const generateAutoCompleteOptions = useCallback((documents: DocumentData[]) => {
    // Synopsis Options
    const synopses = Array.from(new Set(documents
      .map(doc => doc.synopsis)
      .filter(Boolean)))
      .map(synopsis => ({
        label: synopsis as string,
        value: synopsis as string
      }));
    setSynopsisOptions(synopses);

    // File No Options
    const fileNos = Array.from(new Set(documents
      .map(doc => doc.fileNo)
      .filter(Boolean)))
      .map(fileNo => ({
        label: fileNo as string,
        value: fileNo as string
      }));
    setFileNoOptions(fileNos);
  }, []);

  // --- Filter by Synopsis (Filename) and Search ---
  useEffect(() => {
    if (!permissionData?.isView) return;
    if (tableData.length > 0) {
      let filtered = [...tableData];
      
      // Apply synopsis/filename filter (dropdown selection)
      if (selectedSynopsis && selectedSynopsis.value) {
        filtered = filtered.filter(item => 
          item.fileDef && item.fileDef.toLowerCase().includes(String(selectedSynopsis.value).toLowerCase())
        );
      }
      
      // Apply global search query (free text)
      if (searchQuery) {
        filtered = filtered.filter(item => 
          (item.fileNo && item.fileNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (item.fileDef && item.fileDef.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      }
      
      setFilteredData(filtered);
      setPage(0); // Reset to first page when filters change
    } else {
      setFilteredData([]);
    }
  }, [selectedSynopsis, searchQuery, tableData, permissionData?.isView]);

  // --- Pagination Handlers ---
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // --- Get current page data ---
  const paginatedData = useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    return filteredData.slice(start, end);
  }, [filteredData, page, rowsPerPage]);

  // --- useEffect Hooks ---
  useEffect(() => {
    const initData = async () => {
      if (!permissionData?.isView) return;
      if (initialSetupDone.current) return;
      
      try {
        await fetchDepartments();
        await fetchDocTypes();
        initialSetupDone.current = true;
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    initData();
  }, [fetchDepartments, fetchDocTypes, permissionData?.isView]);

  useEffect(() => {
    if (!permissionData?.isView) return;
    if (!initialSetupDone.current || initialDataFetched.current) return;

    const timer = setTimeout(() => {
      fetchDocuments();
      initialDataFetched.current = true;
    }, 300);

    return () => clearTimeout(timer);
  }, [initialSetupDone.current, fetchDocuments, permissionData?.isView]);

  useEffect(() => {
    if (!permissionData?.isView) return;
    if (!initialDataFetched.current) return;

    const timer = setTimeout(() => {
      fetchDocuments();
    }, 500);

    return () => clearTimeout(timer);
  }, [
    selectedDocType?.value,
    selectedDepartment?.value,
    selectedFileNo?.value,
    fetchDocuments,
    permissionData?.isView,
  ]);

  // --- Event Handlers for Table ---
  const handleInputChange = (id: number, field: keyof TableRowData, value: any) => {
    if (!permissionData?.isAdd) {
      toast.error("You don't have permission to edit");
      return;
    }
    setTableData((prev) => {
      const updated = prev.map((row) => (row.id === id ? { ...row, [field]: value } : row));
      
      // Also update filtered data to reflect changes
      setFilteredData((prevFiltered) => 
        prevFiltered.map((row) => (row.id === id ? { ...row, [field]: value } : row))
      );
      
      return updated;
    });
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!permissionData?.isAdd) {
      toast.error("You don't have permission to select");
      return;
    }
    const isChecked = event.target.checked;
    
    // Update all rows in filtered data
    setFilteredData((prev) => prev.map((row) => ({ ...row, isSelected: isChecked })));
    
    // Also update main table data
    setTableData((prev) => 
      prev.map((row) => {
        const isInFiltered = filteredData.some(f => f.id === row.id);
        return isInFiltered ? { ...row, isSelected: isChecked } : row;
      })
    );
  };

  // Check if a row is selected (for header checkbox)
  const numSelected = filteredData.filter((row) => row.isSelected).length;
  const rowCount = filteredData.length;
  const isAllSelected = rowCount > 0 && numSelected === rowCount;



  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: 'calc(100vh - 64px)' }}>
      <ToastApp />
      <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            {t("text.UpdatePdf")}
          </Typography>
          <Button variant="outlined" size="small" onClick={() => navigate(-1)} startIcon={<ArrowBackSharpIcon />} sx={{ borderColor: 'primary.contrastText', color: 'primary.contrastText', '&:hover': { bgcolor: 'primary.dark' } }}>
            {t("text.Back")}
          </Button>
        </Box>

        <CardContent sx={{ p: 3 }}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              {/* Filters Section */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ mb: 2 }}>
                  <CardContent sx={{ p: 2 }}>
                <Box
                 onClick={toggleFilters}   
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',          // dd
    gap: 1                     // spacing
  }}
>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FilterListIcon sx={{ mr: 1, fontSize: 20 }} />
                        <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 500 }}>Filters</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Button
  variant="outlined"
  size="small"
  sx={{
    width: { xs: '100%', sm: 'auto' }   // 🔥 mobile full width
  }} onClick={(e) => { e.stopPropagation(); handleResetFilters(); }}>Reset</Button>
                        <IconButton size="small">{filtersExpanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
                      </Box>
                    </Box>

                    <Collapse in={filtersExpanded}>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        {/* 1. Department Filter */}
                        <Grid item xs={12} sm={6} md={3}>
                          <Autocomplete
                            options={departmentOptions}
                            value={selectedDepartment}
                            onChange={handleDepartmentChange}
                            getOptionLabel={(option) => option.label}
                            loading={loadingDepartments}
                            disabled={isDevIdPresent}
                            size="small"
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Department" 
                                placeholder={isDevIdPresent ? "Pre-selected from secure ID" : "Select department"} 
                                InputProps={{ 
                                  ...params.InputProps, 
                                  endAdornment: ( 
                                    <> 
                                      {loadingDepartments ? <CircularProgress size={18} /> : null} 
                                      {params.InputProps.endAdornment} 
                                    </> 
                                  ) 
                                }} 
                              />
                            )}
                          />
                        </Grid>

                        {/* 2. Document Type Filter */}
                        <Grid item xs={12} sm={6} md={3}>
                          <Autocomplete
                            options={docTypeOptions}
                            value={selectedDocType}
                            onChange={handleDocTypeChange}
                            getOptionLabel={(option) => option.label}
                            loading={isLoadingDocTypes}
                            size="small"
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Document Type" 
                                placeholder="Select document type"
                                error={formik.touched.docID && Boolean(formik.errors.docID)}
                                helperText={formik.touched.docID && formik.errors.docID}
                                InputProps={{ 
                                  ...params.InputProps, 
                                  endAdornment: ( 
                                    <> 
                                      {isLoadingDocTypes ? <CircularProgress size={18} /> : null} 
                                      {params.InputProps.endAdornment} 
                                    </> 
                                  ) 
                                }} 
                              />
                            )}
                          />
                        </Grid>

                        {/* 3. File Name (Synopsis) Filter */}
                        <Grid item xs={12} sm={6} md={3}>
                          <Autocomplete
                            options={synopsisOptions}
                            value={selectedSynopsis}
                            onChange={handleSynopsisChange}
                            getOptionLabel={(option) => option.label}
                            size="small"
                            renderInput={(params) => (
                              <TextField {...params} label="File Name" placeholder="Select file name" />
                            )}
                          />
                        </Grid>

                        {/* 4. File No Filter */}
                        <Grid item xs={12} sm={6} md={3}>
                          <Autocomplete
                            options={fileNoOptions}
                            value={selectedFileNo}
                            onChange={handleFileNoChange}
                            getOptionLabel={(option) => option.label}
                            size="small"
                            renderInput={(params) => (
                              <TextField {...params} label="File No" placeholder="Select file number" />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Collapse>
                  </CardContent>
                </Card>
              </Grid>

              {/* Global Search Bar - Above Table */}
              <Grid item xs={12} sx={{ mt: -1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Global Search by File No or File Name..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{ width: '350px' }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Grid>

              {/* Table Section */}
              <Grid item xs={12} sx={{ mt: -2 }}>
                
                {isLoadingDocs ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}><CircularProgress /></Box>
                ) : filteredData.length === 0 ? (
                  <Alert severity="info" sx={{ mt: 2 }}>No documents found for the selected filters.</Alert>
                ) : (
                  <>
                    <TableContainer component={Paper} elevation={1} sx={{ maxHeight: '50vh' }}>
                      <Table stickyHeader>
                        <TableHead>
                          {/* Table Headers */}
                          <TableRow sx={{ '& th': { backgroundColor: 'lightblue', fontWeight: 'bold' } }}>
                            <TableCell padding="checkbox">
                              {permissionData?.isAdd && (
                                <Checkbox 
                                  color="primary" 
                                  indeterminate={numSelected > 0 && numSelected < rowCount} 
                                  checked={isAllSelected} 
                                  onChange={handleSelectAll} 
                                  disabled={isSubmitting} 
                                />
                              )}
                            </TableCell>
                            <TableCell>File No</TableCell>
                            <TableCell>PDF File Name</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {paginatedData.map((row, index) => (
                            <TableRow 
                              hover 
                              key={row.id} 
                              selected={row.isSelected}
                              sx={{ 
                                backgroundColor: index % 2 === 0 ? '#fafafa' : '#ffffff',
                                '&:hover': {
                                  backgroundColor: '#f5f5f5 !important',
                                }
                              }}
                            >
                              <TableCell padding="checkbox">
                                {permissionData?.isAdd && (
                                  <Checkbox 
                                    color="primary" 
                                    checked={row.isSelected} 
                                    onChange={(e) => handleInputChange(row.id, "isSelected", e.target.checked)} 
                                    disabled={isSubmitting} 
                                  />
                                )}
                              </TableCell>
                              <TableCell>{row.fileNo}</TableCell>
                              <TableCell>
                                <TextField 
                                  variant="outlined" 
                                  size="small" 
                                  fullWidth 
                                  value={row.fileDef} 
                                  onChange={(e) => handleInputChange(row.id, "fileDef", e.target.value)} 
                                  disabled={!row.isSelected || isSubmitting || !permissionData?.isAdd} 
                                  sx={{ 
                                    backgroundColor: row.isSelected ? 'white' : 'transparent', 
                                    minWidth: '250px' 
                                  }} 
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Pagination */}
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50, 100]}
                      component="div"
                      count={filteredData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      labelRowsPerPage="Rows per page:"
                    />
                  </>
                )}
              </Grid>

              {/* Action Buttons */}
              {filteredData.length > 0 && permissionData?.isAdd && (
                <Grid item xs={12} container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="submit" variant="contained" color="primary" fullWidth disabled={isSubmitting || numSelected === 0} startIcon={isSubmitting ? <CircularProgress size={20} /> : null}>
                      {isSubmitting ? "Saving..." : "Save"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="reset" variant="outlined" color="secondary" fullWidth disabled={isSubmitting} onClick={() => { formik.resetForm(); handleResetFilters(); }}>
                      {t("text.reset")}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </form>
        </CardContent>
      </Paper>
    </Box>
  );
};

export default UpdatePDF;